import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Container, Modal, Tab } from "@mui/material";
import { useState } from "react";
import TopTitleNoteContainer from "./TopTitleNoteContainer";
import QuickNotesContainer from "../containers/QuickNotesContainer";
import TherapyNoteContainer from "../containers/TherapyNoteContainer";
import NonTherapyNoteContainer from "../containers/NonTherapyNoteContainer";
import FamilyNotesContainer from "../containers/FamilyNotesContainer";
import MedicalNotes from "../containers/MedicalNotes";
import AddQuickNote from "./AddQuickNote";
import AddTherapyNote from "./AddTherapyNote";
import AddNonTherapyNote from "./AddNonTherapyNote";
import AddFamilyNote from "./AddFamilyNote";
import AddGroupNote from "./AddGroupNote";
import AddMedicalNote from "./AddMedicalNote";
import { useTheme } from "@mui/material/styles";
import AddAftercareNote from "./AddAftercareNote";
import AftercareNotesContainer from "../../containers/AftercareNotesContainer";
import AddCBTNote from "./AddCBTNote";
import CbtNotesContainer from "../containers/CbtNotesContainer";
import GroupNotesByClient from "../containers/GroupNotesByClient";

function NotesTabTherapist(props) {
  const theme = useTheme();
  const tabListStyle = {
    flexGrow: 1,
    whiteSpace: "nowrap",
    "& .MuiTab-root": {
      minWidth: "auto",
      [theme.breakpoints.down("sm")]: {
        flexBasis: "50%",
      },
    },
  };

  const styleLive2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleFamilyNote = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleGroupNote = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: 750,
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const dateToday = new Date();
  const [value, setValue] = useState("0");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [openQuickNote, setOpenQuickNote] = useState(false);
  const [openTherapyNote, setOpenTherapyNote] = useState(false);
  const [openNonTherapyNote, setOpenNonTherapyNote] = useState(false);
  const [openFamilyNote, setOpenFamilyNote] = useState(false);
  const [openGroupNote, setOpenGroupNote] = useState(false);
  const [openMedicalNote, setOpenMedicalNote] = useState(false);
  const [openAftercareNote, setOpenAftercareNote] = useState(false);
  const [openCbtNote, setOpenCbtNote] = useState(false);
  const handleOpenQuickNote = () => setOpenQuickNote(true);
  const handleOpenTherapyNote = () => setOpenTherapyNote(true);
  const handleOpenNonTherapyNote = () => setOpenNonTherapyNote(true);
  const handleOpenFamilyNote = () => setOpenFamilyNote(true);
  const handleOpenGroupNote = () => setOpenGroupNote(true);
  const handleOpenMedicalNote = () => setOpenMedicalNote(true);
  const handleOpenAftercareNote = () => setOpenAftercareNote(true);
  const handleOpenCbtNote = () => setOpenCbtNote(true);
  const handleCloseTherapyNote = () => setOpenTherapyNote(false);
  const handleCloseNonTherapyNote = () => setOpenNonTherapyNote(false);
  const handleCloseQuickNote = () => setOpenQuickNote(false);
  const handleCloseFamilyNote = () => setOpenFamilyNote(false);
  const handleCloseGroupNote = () => setOpenGroupNote(false);
  const handleCloseMedicalNote = () => setOpenMedicalNote(false);
  const handleCloseAftercareNote = () => setOpenAftercareNote(false);
  const handleCloseCbtNote = () => setOpenCbtNote(false);

  return (
    <div className="tab-container-white">
      <div className="tab-form-container">
        <Modal
          open={openQuickNote}
          onClose={handleCloseQuickNote}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleLive2}>
            <AddQuickNote
              closemodal={handleCloseQuickNote}
              clientId={props.clientId}
              {...props}
            />
          </Box>
        </Modal>
        <Modal
          open={openTherapyNote}
          onClose={handleCloseTherapyNote}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleLive2}>
            <AddTherapyNote
              dateTherapyNote={dateToday}
              closemodal={handleCloseTherapyNote}
              clientId={props.clientId}
              {...props}
            />
          </Box>
        </Modal>
        <Modal
          open={openNonTherapyNote}
          onClose={handleCloseNonTherapyNote}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleLive2}>
            <AddNonTherapyNote
              dateNonTherapyNote={dateToday}
              closemodal={handleCloseNonTherapyNote}
              clientId={props.clientId}
              {...props}
            />
          </Box>
        </Modal>

        <Modal
          open={openFamilyNote}
          onClose={handleCloseFamilyNote}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleFamilyNote}>
            <AddFamilyNote
              dateNonTherapyNote={dateToday}
              closemodal={handleCloseFamilyNote}
              clientId={props.clientId}
              {...props}
            />
          </Box>
        </Modal>
        <Modal
          open={openGroupNote}
          onClose={handleCloseGroupNote}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleGroupNote}>
            <AddGroupNote
              dateNonTherapyNote={dateToday}
              closemodal={handleCloseGroupNote}
              clientId={props.clientId}
              {...props}
            />
          </Box>
        </Modal>
        <Modal
          open={openMedicalNote}
          onClose={handleCloseMedicalNote}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleLive2}>
            <AddMedicalNote
              dateNonTherapyNote={dateToday}
              closemodal={handleCloseMedicalNote}
              clientId={props.clientId}
              {...props}
            />
          </Box>
        </Modal>

        <Modal
          open={openAftercareNote}
          onClose={handleCloseAftercareNote}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleLive2}>
            <AddAftercareNote
              dateNonTherapyNote={dateToday}
              closemodal={handleCloseAftercareNote}
              clientId={props.clientId}
              {...props}
            />
          </Box>
        </Modal>
        <Modal
          open={openCbtNote}
          onClose={handleCloseCbtNote}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleLive2}>
            <AddCBTNote
              closemodal={handleCloseCbtNote}
              clientId={props.clientId}
              firstName={props.firstName}
              lastName={props.lastName}
              profilePicture={props.profilePicture}
            />
          </Box>
        </Modal>
        <Container maxWidth="lg">
          <Box sx={{ padding: "16px" }}>
            <TabContext value={value}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  width: "auto",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    overflowX: "auto",
                    "&::-webkit-scrollbar": {
                      width: "0.5em",
                      height: "0.5em",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                    },
                  }}
                >
                  <TabList
                    aria-label="Tabs example"
                    onChange={handleChange}
                    sx={tabListStyle}
                    variant="scrollable"
                    scrollButtons="auto"
                    value={value}
                  >
                    <Tab label="Quick notes" value="0" />
                    <Tab label="1 to 1 therapy session notes" value="1" />
                    <Tab label="1 to 1 support staff notes" value="2" />
                    <Tab label="Medical notes" value="3" />
                    <Tab label="Support Aftercare notes" value="4" />
                    <Tab label="Family / significant other notes" value="5" />
                    <Tab label="CBT notes" value="6" />
                    <Tab label="Group notes" value="7" />
                    {/* <Tab label="All notes" value="6" /> */}
                  </TabList>
                </Box>
              </Box>
              {(() => {
                switch (value) {
                  case "0":
                    return (
                      <TabPanel value="0">
                        <TopTitleNoteContainer
                          title="Add quick note"
                          handleOpen={handleOpenQuickNote}
                        />
                        <QuickNotesContainer
                          clientId={props.clientId}
                          {...props}
                        />
                      </TabPanel>
                    );
                  case "1":
                    return (
                      <TabPanel value="1">
                        <TopTitleNoteContainer
                          title="Add 1 to 1 therapy note"
                          handleOpen={handleOpenTherapyNote}
                        />
                        <TherapyNoteContainer
                          clientId={props.clientId}
                          {...props}
                        />
                      </TabPanel>
                    );
                  case "2":
                    return (
                      <TabPanel value="2">
                        <TopTitleNoteContainer
                          title="Add 1 to 1 support staff notes"
                          handleOpen={handleOpenNonTherapyNote}
                        />
                        <NonTherapyNoteContainer
                          clientId={props.clientId}
                          {...props}
                        />
                      </TabPanel>
                    );
                  case "3":
                    return (
                      <TabPanel value="3">
                        <TopTitleNoteContainer
                          title="Add medical note"
                          handleOpen={handleOpenMedicalNote}
                        />
                        <MedicalNotes clientId={props.clientId} {...props} />
                      </TabPanel>
                    );
                  case "4":
                    return (
                      <TabPanel value="4">
                        <TopTitleNoteContainer
                          title="Add support aftercare note"
                          handleOpen={handleOpenAftercareNote}
                        />
                        <AftercareNotesContainer
                          clientId={props.clientId}
                          {...props}
                        />
                      </TabPanel>
                    );
                  case "5":
                    return (
                      <TabPanel value="5">
                        <TopTitleNoteContainer
                          title="Add family/significant other note"
                          handleOpen={handleOpenFamilyNote}
                        />
                        <FamilyNotesContainer
                          clientId={props.clientId}
                          {...props}
                        />
                      </TabPanel>
                    );
                  case "6":
                    return (
                      <TabPanel value="6">
                        <TopTitleNoteContainer
                          title="Add CBT note"
                          handleOpen={handleOpenCbtNote}
                        />
                        <CbtNotesContainer />
                      </TabPanel>
                    );
                  case "7":
                    return (
                      <TabPanel value="7">
                        <TopTitleNoteContainer
                          title="Add group note"
                          handleOpen={handleOpenGroupNote}
                        />
                        <GroupNotesByClient clientId={props.clientId} />
                      </TabPanel>
                    );
                  // case "6":
                  //   return (
                  //     <TabPanel value="6">
                  //       <AllNotesContainer
                  //         clientId={props.clientId}
                  //         {...props}
                  //       />
                  //     </TabPanel>
                  //   );

                  default:
                    return null;
                }
              })()}
            </TabContext>
          </Box>
        </Container>
      </div>
    </div>
  );
}

export default NotesTabTherapist;
